module.exports = __webpack_public_path__ + "static/media/mov (1).512f47eb.svg";